import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccGoalComment } from '@interfaces';


export function getColumns(util: UtilityService) {
	const columns: GridColumn<AccGoalComment, unknown>[] = [
		buildColumn(util, 'Id', row => row.accGoalCommentId),
		buildColumn(util, 'Text', row => row.personName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.commentType, { header: 'Type' }),
		buildColumn(util, 'Text', row => row.comment, { header: 'Comment' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Last Updated' }),
		buildColumn(util, 'Text', row => row.updatedByPersonName, { header: 'Last Updated By', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Created', hidden: true }),
		buildColumn(util, 'Text', row => row.createdByPersonName, { header: 'Created By', hidden: true }),
	];

	return columns;

}
